import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Home, MessageCircle, Sparkles, Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const HIDDEN = [/^\/$/, /^\/login/, /^\/register/, /^\/chat\//, /^\/coach/];

const tabClass = (active) =>
  `flex-1 flex flex-col items-center justify-center gap-1 py-2 text-[11px] font-medium transition-colors duration-200 ${
    active ? "text-[#2A3B32]" : "text-[#5C6A61]"
  }`;

export const BottomTabBar = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (!user || user.role === "admin" || HIDDEN.some((r) => r.test(pathname))) return null;

  const openChat = async () => {
    const { data } = await api.get("/sessions");
    const list = Array.isArray(data) ? data : data.sessions || [];
    if (list.length) return navigate(`/chat/${list[0].id}`);
    const { data: s } = await api.post("/sessions", { category: "general" });
    navigate(`/chat/${s.id}`);
  };

  const Tab = ({ to, icon: Icon, label, id }) => (
    <NavLink to={to} data-testid={`tab-${id}`} className={({ isActive }) => tabClass(isActive)}>
      {({ isActive }) => (
        <>
          <Icon size={22} strokeWidth={isActive ? 2.2 : 1.7} className={isActive ? "text-[#E07A5F]" : ""} />
          {label}
        </>
      )}
    </NavLink>
  );

  return (
    <>
      <div className="h-20 md:hidden" aria-hidden="true" />
      <nav
        className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[#2A3B32]/10 bg-[#FDFBF7]/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]"
        data-testid="bottom-tab-bar"
      >
        <div className="flex h-16">
          <Tab to="/dashboard" icon={Home} label="Home" id="home" />
          <button onClick={openChat} data-testid="tab-chat" className={tabClass(false)}>
            <MessageCircle size={22} strokeWidth={1.7} />
            Chat
          </button>
          <Tab to="/program" icon={Sparkles} label="Program" id="program" />
          <Tab to="/words" icon={Heart} label="Words" id="words" />
        </div>
      </nav>
    </>
  );
};
